//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
	props: ['resource', 'lineclamp'],
	components: {
		Readmore: () => import('~/components/Readmore.vue'),
	},
	computed: {
		...mapState({
			modal: ({ modalStore: {modal} }) => modal,
		}),
		startsWithParagraph() {
			return this.resource?.description?.trim().startsWith("<p>");
		}
	},
	data() { 
		return {
			read: {
				text: 'Lees meer',
				active: false  
			} 
		}
	},
	methods: {
		readmore() {
			this.read.active = !this.read.active;
			if (this.read.active) {
				this.read.text = 'Lees minder'
			} else {
				this.read.text = 'Lees meer'
			}
		},
	}
}
